import { createAction } from '@reduxjs/toolkit'

export enum Field {
  CURRENCY_A = 'CURRENCY_A',
  CURRENCY_B = 'CURRENCY_B',
}

export const typeInput = createAction<{ field: Field; typedValue: string; noLiquidity: boolean }>(
  'mintCharm/typeInputMint'
)

export const resetMintState = createAction<void>('mintCharm/resetMintState')

export const switchFields = createAction<{
  independentField: Field
  typedValue: string
  otherTypedValue: string
}>('mintCharm/switchFields')

export const setSlippageTolerance = createAction<{ slippageTolerance: number }>('mintCharm/setSlippageTolerance')

export const setDeadline = createAction<{ deadline: number }>('mintCharm/setDeadline')
